import { render, staticRenderFns } from "./calendarEvent.vue?vue&type=template&id=8661c28e&scoped=true&"
import script from "./calendarEvent.vue?vue&type=script&lang=js&"
export * from "./calendarEvent.vue?vue&type=script&lang=js&"
import style0 from "./calendarEvent.vue?vue&type=style&index=0&id=8661c28e&scoped=true&lang=css&"
import style1 from "./calendarEvent.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8661c28e",
  null
  
)

export default component.exports